module.exports = __webpack_public_path__ + "img/circle_active_large.c8c65cdc.png";